import { TradeControllerVariants } from '../../../utils';

export const allTradeOperations: TradeControllerVariants[] = [
  'buy',
  'sell',
  'savings',
  'swap',
  'stake',
  'unstake',
  'order',
] as const;
